"use client";

import { RouteErrorBoundary } from "@/app/_components/ui/route-error-boundary";

export default function PortalGroupError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <RouteErrorBoundary boundary="(portal)" error={error} reset={reset} />;
}
